var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-form", {
    ref: "form",
    attrs: {
      size: "mini",
      model: _vm.form,
      rules: _vm.rules,
      "label-position": "right",
      "label-width": "140px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "函证对象名称",
      prop: "c03CusName"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入内容",
      disabled: _vm.type === "check"
    },
    model: {
      value: _vm.form.c03CusName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "c03CusName", $$v);
      },
      expression: "form.c03CusName"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "函证对象类型",
      prop: "c03CusType"
    }
  }, [_c("cpsc-select", {
    attrs: {
      disabled: _vm.type === "check",
      placeholder: "请选择函证对象类型"
    },
    model: {
      value: _vm.form.c03CusType,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "c03CusType", $$v);
      },
      expression: "form.c03CusType"
    }
  }, _vm._l(_vm.typeOptions, function (item) {
    return _c("el-option", {
      key: item,
      attrs: {
        label: item,
        value: item
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "核验方式",
      prop: "c03CheckType"
    }
  }, [_c("cpsc-select", {
    attrs: {
      placeholder: "请选择核验方式"
    },
    model: {
      value: _vm.form.c03CheckType,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "c03CheckType", $$v);
      },
      expression: "form.c03CheckType"
    }
  }, _vm._l(_vm.options, function (item) {
    return _c("el-option", {
      key: item.n04Id,
      attrs: {
        label: item.n04Value,
        value: item.n04Value
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "工商登记注册地址",
      prop: "c03CorrectAddress"
    }
  }, [_c("el-input", {
    attrs: {
      disabled: !_vm.isArtificial,
      placeholder: "请输入内容"
    },
    model: {
      value: _vm.form.c03CorrectAddress,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "c03CorrectAddress", $$v);
      },
      expression: "form.c03CorrectAddress"
    }
  })], 1), [_c("el-form-item", {
    attrs: {
      label: "核验过程",
      prop: "c03CheckProcess"
    }
  }, [_c("editor", {
    staticClass: "my-editor",
    attrs: {
      "default-val": _vm.editText,
      "is-document": false
    },
    on: {
      change: _vm.processChange
    }
  })], 1), _c("el-row", {
    attrs: {
      gutter: 15
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "核验人"
    }
  }, [_vm._v(" " + _vm._s(_vm.$getStaffName(_vm.form.c03CheckStaff)) + " ")])], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "核验日期"
    }
  }, [_vm._v(" " + _vm._s(_vm._f("date")(_vm.form.c03CheckDate, "yyyy-MM-dd")) + " ")])], 1)], 1)]], 2), _c("div", {
    staticClass: "dialog-btn-wrap"
  }, [!_vm.readOnly ? [_vm.form.updatable && _vm.type === "check" ? _c("el-button", {
    attrs: {
      type: "success",
      size: "mini",
      loading: _vm.loading
    },
    on: {
      click: function click($event) {
        return _vm.submit("check");
      }
    }
  }, [_vm._v("核验")]) : _vm._e(), _vm.form.updatable && _vm.type === "edit" || _vm.type === "create" ? _c("el-button", {
    attrs: {
      type: "primary",
      size: "mini",
      loading: _vm.loading
    },
    on: {
      click: function click($event) {
        return _vm.submit("modify");
      }
    }
  }, [_vm._v("保存")]) : _vm._e()] : _vm._e(), _c("el-button", {
    attrs: {
      type: "text",
      size: "mini",
      loading: _vm.loading
    },
    on: {
      click: _vm.cancel
    }
  }, [_vm._v("关闭")])], 2)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };